import { useEffect, useRef, useState } from 'react';

const useStateCb = (defaultValue) => {
  const callbackRef = useRef(() => {});
  const [stateValue, setStateValue] = useState(defaultValue);

  useEffect(() => {
    callbackRef.current(stateValue);
    callbackRef.current = null;
  }, [stateValue]);

  const setValue = (newValue, callback) => {
    if (newValue !== stateValue) {
      callbackRef.current = callback;
      setStateValue(newValue);
    } else {
      callback(stateValue);
    }
  };

  return [stateValue, setValue];
};

export default useStateCb;
